'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorMiddleware = exports.InternalServerError = exports.NotFoundError = exports.ForbiddenError = exports.BadRequestError = exports.UnauthorizedError = exports.HttpError = exports.createErrorResponse = void 0;
function createErrorResponse(anyErr) {
    let message = 'Internal server error';
    if (Array.isArray(anyErr)) {
        return {
            message,
            errs: anyErr
        };
    }
    if (!(anyErr instanceof HttpError)) {
        return {
            message,
            errs: [anyErr]
        };
    }
    return {
        message: anyErr.message,
        errs: [anyErr.err]
    };
}
exports.createErrorResponse = createErrorResponse;
class HttpError extends Error {
    constructor(message, code = 500, err) {
        super();
        this.code = code;
        this.message = message;
        this.err = err;
    }
    get statusCode() {
        return this.code;
    }
}
exports.HttpError = HttpError;
class UnauthorizedError extends HttpError {
    constructor(err) {
        super('Unauthorized', 401, err);
    }
}
exports.UnauthorizedError = UnauthorizedError;
class BadRequestError extends HttpError {
    constructor(err) {
        super('Bad request', 400, err);
    }
}
exports.BadRequestError = BadRequestError;
class ForbiddenError extends HttpError {
    constructor(err) {
        super('Forbidden', 403, err);
    }
}
exports.ForbiddenError = ForbiddenError;
class NotFoundError extends HttpError {
    constructor(err) {
        super('Not found', 404, err);
    }
}
exports.NotFoundError = NotFoundError;
class InternalServerError extends HttpError {
    constructor(err) {
        let message = "Internal server error";
        if (err) {
            message += ": " + err.message;
        }
        super(message, 500, err);
    }
}
exports.InternalServerError = InternalServerError;
function errorMiddleware(err, req, res, next) {
    console.error("error handling", err);
    const errorResponse = createErrorResponse(err);
    if (err instanceof HttpError) {
        return res.status(err.statusCode).json(errorResponse);
    }
    return res.status(500).json(errorResponse);
}
exports.errorMiddleware = errorMiddleware;
